import React        from 'react'
import MatchDetails from './components/MatchDetails'
import MatchStats   from './components/MatchStats'
import MatchEvents  from './components/MatchEvents'
//import Article    from './components/article'
import PlayersList  from './components/PlayersList'
import Conversation from './components/Conversation'
import Commentary   from './components/Commentary'
import PlayerStats  from './components/PlayerStats'
import Glossary     from './components/Glossary'
import MatchHistory from './components/MatchHistory'
//import TeamStats    from './components/TeamStats'
import selectn from 'selectn'

import { Ad, StandingsModule, NewsModule, TopStories } from '../../common'
import { isBet365KioskEdition } from '../../../lib/utils/common'

/**
 * Generate the Game package view for Rugby
 * @param  {String} options.pageType PageType
 * @param  {Object} options.state    Application state
 * @return {Object}                  Arrays having React components for each column
 */
export const getRugbyView = ({
    pageType  = 'game',
    state     = {},
    params = {}
    //query
}) => {

  let appView = ''
  const bet365Kiosk = isBet365KioskEdition(state.edition)

  const columnThree = [
    bet365Kiosk &&
    <div key="kiosk-ad" className="sub-module">
      <Ad id="bet365" className="ad-slot-incontent-strip ad-wrapper" slotType="incontentstrip" />
    </div>,
    <div key="ad" className="sub-module">
      <Ad id="mpu" className="ad-slot-incontent ad-wrapper" slotType="incontent" />
    </div>,
    <StandingsModule key="s" {...state.standings} />,
    <NewsModule key="nm" {...state.news}  />   
  ]

  switch(pageType) {
    case 'game':
    case 'match':
      appView = getSummary({ state, columnThree, params })
      break
      
    case 'commentary':
      appView = getCommentary({ state, columnThree })
      break

    case 'matchstats':
      appView = getMatchStats({ state, columnThree })
      break
      
    case 'playerstats':
      appView = getPlayerStats({ state, columnThree })
      break
      
    case 'lineups':
      appView = getLineups({ state, columnThree })
      break

    case 'conversation':
      appView = getConversation({ state, columnThree })
      break     
      
    case 'preview':
    case 'report':
      appView = getArticleContent({ state, columnThree })
      break
  }

  return appView
}

const getMatchStats = ({ state, columnThree }) => {
  const isTeamLinkActive = selectn('matchStats.isTeamLinkActive', state)
  return (
    <div className="layout-bc">
      <div className="col-b">
        <MatchEvents key="mevt" {...state.matchEvents} />
        <MatchEvents key="matt" {...state.matchAttacking} />
        <MatchEvents key="mdef" {...state.matchDefending} />
        <MatchEvents key="mdis" {...state.matchDiscipline} />
        <MatchHistory key="h2h" {...state.headToHead} sport="rugby" head2head="true" isTeamLinkActive={isTeamLinkActive} isWebView={state.isWebView} />
        <MatchHistory key="hf" {...state.matchHomeForm} isTeamLinkActive={isTeamLinkActive} isWebView={state.isWebView} />
        <MatchHistory key="af" {...state.matchAwayForm} isTeamLinkActive={isTeamLinkActive} isWebView={state.isWebView} />        
      </div>
      <div className="col-c">
        {columnThree}
      </div>
    </div>
  )
}

const getPlayerStats = ({ state, columnThree }) => {
  return (
    <div className="layout-bc">
      <div className="col-b">
        <PlayerStats key="ps" {...state.matchLineUp} glossary={state.matchGlossary.playerStats} />
        <Glossary key="gloss" glossary={state.matchGlossary.playerStats} />
      </div>
      <div className="col-c">
        {columnThree}
      </div>
    </div>
  )
}

const getConversation = ({ state, columnThree }) => {
  return (
    <div className="layout-bc">
      <div className="col-b">
        <Conversation key="conv" {...state.matchConversation} />
      </div>
      <div className="col-c">
        {columnThree}
      </div>
    </div>
  )
}

const getLineups = ({ state, columnThree }) => {
  return (
    <div className="layout-bc">
      <div className="col-b">
        <PlayersList key="sq" {...state.matchLineUp} />
      </div>
      <div className="col-c">
        {columnThree}
      </div>
    </div>
  )
}

const getArticleContent = ({ state, columnThree }) => {
  let articleMarkup = selectn('article.html',state) || ''
  articleMarkup = articleMarkup.replace('<\\/script>','<\/script>')
  return (
    <div className="main-content react-content">
      <div id="gamepackage-wrap">
        <div id="gamepackage-content-wrap" className="layout-bc">
          <section id="article-feed" className="col-b" 
          data-behavior="author_overlay article_header_news_feed_item_meta social_tools comment" 
          dangerouslySetInnerHTML={{ __html: articleMarkup }} />
          <section className="col-c"> 
            {columnThree}
          </section>
        </div>
      </div>
    </div>
  )
}

const getCommentary = ({ state, columnThree }) => {
  return (
    <div className="layout-cbc">
      <div className="col-one">
        <PlayersList key="sq" {...state.matchLineUp} />
        <MatchDetails key="m" {...state.matchDetails} />
      </div>
      <div className="col-two">
        <Commentary key="conv" {...state.matchCommentary} showAll={true}/>
      </div>
      <div className="col-three">
        {columnThree}
      </div>
    </div>
  )
}

const TopStory = ({
  article = {}
}) => {

  if ( !article ) {
    return null
  }
  
  return (
    <TopStories key="t" content={article} image={ article.images && article.images[0] || {} } />
  )
}

const getSummary = ({ state, columnThree }) => {

  const isSmallDevice = state.isSmallDevice || false
  const isTabletDevice = state.isTabletDevice || false
  const isSmallDesktopDevice = state.isSmallDesktopDevice || false
  const matchLineUp = state.matchLineUp || {}

  // default columns 'pre' state
  let columnOne = isSmallDevice ? [] : [
    matchLineUp.show && <PlayersList key="sq" {...matchLineUp} />,
    <MatchDetails key="m" {...state.matchDetails} />
  ]

  const matchDetails = (isSmallDevice || isTabletDevice || isSmallDesktopDevice) ? <MatchDetails key="m" {...state.matchDetails} /> : ''
  
  const isTeamLinkActive = selectn('matchStats.isTeamLinkActive', state)
  let columnTwo = [
    <TopStory key="t" article={state.article} />,
    <Commentary key="c" {...state.matchCommentary} />,
    <MatchHistory key="h2h" {...state.headToHead} sport="rugby" head2head="true" isTeamLinkActive={isTeamLinkActive} isWebView={state.isWebView} />,
    <MatchHistory key="hf" {...state.matchHomeForm} isTeamLinkActive={isTeamLinkActive} isWebView={state.isWebView} />,
    <MatchHistory key="af" {...state.matchAwayForm} isTeamLinkActive={isTeamLinkActive} isWebView={state.isWebView} />,
    matchDetails,
    !state.isWebView && <Conversation key="conv" {...state.matchConversation} />
  ]

  switch(state.gameState) {
    case 'live':
      columnOne = isSmallDevice ? [] : [
        matchLineUp.show && <PlayersList key="sq" {...matchLineUp} />,
        <MatchDetails key="m" {...state.matchDetails} />
      ]
      columnTwo = [
        <Commentary key="c" {...state.matchCommentary} />,
        <MatchStats key="ms" {...state.matchStats} />,    
        matchDetails,
        !state.isWebView && <Conversation key="conv" {...state.matchConversation} />
      ]
      break

    case 'final':
      columnOne = isSmallDevice ? [] : [
        matchLineUp.show && <PlayersList key="sq" {...matchLineUp} />,
        <MatchDetails key="m" {...state.matchDetails} />
      ]
      columnTwo = [
        <TopStories key="t" content={state.article} image={ state.article.images && state.article.images[0] || {} } />,
        <Commentary key="c" {...state.matchCommentary} />,
        <MatchStats key="ms" {...state.matchStats} />,    
        matchDetails,
        !state.isWebView && <Conversation key="conv" {...state.matchConversation} />
      ]
      break
  }

  return (
    <div className="layout-cbc">
      <div className="col-one">
        {columnOne}
      </div>
      <div className="col-two">
        {columnTwo}
      </div>
      <div className="col-three">
        {columnThree}
      </div>
    </div>
  )
}

export default getRugbyView



// WEBPACK FOOTER //
// ../app/components/gamepackage/rugby/getAppView.js